/**
 *
 * MenuInfoWindow
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { red500 } from 'styles/colors';
import InfoWindow from '../index';

const Wrapper = styled(InfoWindow)`
  .leaflet-popup-content-wrapper {
    padding: 0;
  }
  .list-group {
    margin-bottom: 0;
  }
  .list-group-item {
    padding-right: 20px;
    border: none;
    &:not(:first-child) {
      border-top: 1px solid ${red500};
    }
  }
`;

function MenuInfoWindow(props) {
  const { menu } = props;
  return (
    <Wrapper>
      <ListGroup>
        {menu.map(item => (
          <ListGroupItem key={item.id} onClick={item.action}>
            {item.label}
          </ListGroupItem>
        ))}
      </ListGroup>
    </Wrapper>
  );
}

MenuInfoWindow.propTypes = {
  menu: PropTypes.array.isRequired,
};

export default MenuInfoWindow;
